import { render, staticRenderFns } from "./HeaderDaTabela.vue?vue&type=template&id=2c2e929a&scoped=true"
import script from "./HeaderDaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDaTabela.vue?vue&type=style&index=0&id=2c2e929a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e929a",
  null
  
)

export default component.exports